import styled from "styled-components";

export const ErrorText = styled.div`
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  text-align: left;
`;
